import { useMutation, useQuery, useQueryClient } from "react-query";
import { generatePath } from "react-router-dom";
import { useApiRequest } from "system/api/hooks";
import {
  API_UPDATE_REJECTION_REASON,
  API_CREATE_REJECTION_REASON,
  API_GET_ALL_REJECTION_REASONS,
  API_GET_REJECTION_REASON,
  API_DELETE_REJECTION_REASON,
} from "system/api/apiUrls";
import { useApiErrors } from "system/helpers/apiErrorHelper";
import { useSuccessToast } from "system/helpers/hooks";
import { ErrorType } from "system/helpers/types";
import {
  RejectionReasonsDataType,
  RejectionReasonItemType,
} from "modules/rejectionReasons/types";

const getRejectionReasonsKey = "getRejectionReasonsKey";
const getCurrencyKey = "getCurrencyKey";
export const useGetRejectionReasons = () => {
  const [apiRequest] = useApiRequest();
  return useQuery(
    [getRejectionReasonsKey],
    (): Promise<RejectionReasonsDataType> =>
      apiRequest({
        url: API_GET_ALL_REJECTION_REASONS,
        method: "get",
      })
  );
};
export const useGetRejectionReason = (id: string) => {
  const [apiRequest] = useApiRequest();
  return useQuery(
    [getCurrencyKey, id],
    (): Promise<RejectionReasonItemType> =>
      apiRequest({
        url: generatePath(API_GET_REJECTION_REASON, { id }),
        method: "get",
      })
  );
};

export const useCreateRejectionReason = () => {
  const [apiRequest] = useApiRequest();
  const queryClient = useQueryClient();
  const { apiErrors } = useApiErrors();
  const { apiSuccessMessage } = useSuccessToast();
  return useMutation(
    (data: any) =>
      apiRequest({
        url: generatePath(API_CREATE_REJECTION_REASON, {
          id: data.id,
        }),
        method: "post",
        data: data.data,
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(getRejectionReasonsKey);
        apiSuccessMessage();
      },
      onError: (err: ErrorType) => apiErrors(err),
    }
  );
};
export const useDeleteRejectionReason = () => {
  const [apiRequest] = useApiRequest();
  const queryClient = useQueryClient();
  const { apiErrors } = useApiErrors();
  const { apiSuccessMessage } = useSuccessToast();
  return useMutation(
    (data: any) =>
      apiRequest({
        url: generatePath(API_DELETE_REJECTION_REASON, {
          id: data.id,
        }),
        method: "delete",
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(getRejectionReasonsKey);
        apiSuccessMessage();
      },
      onError: (err: ErrorType) => apiErrors(err),
    }
  );
};
export const useUpdateRejectionReasons = () => {
  const [apiRequest] = useApiRequest();
  const queryClient = useQueryClient();
  const { apiErrors } = useApiErrors();
  const { apiSuccessMessage } = useSuccessToast();
  return useMutation(
    (data: any) =>
      apiRequest({
        url: generatePath(API_UPDATE_REJECTION_REASON, {
          id: data.id,
        }),
        method: "post",
        data: data.data,
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(getRejectionReasonsKey);
        apiSuccessMessage();
      },
      onError: (err: ErrorType) => apiErrors(err),
    }
  );
};
